import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { parse } from 'date-fns';
import { Subject } from 'rxjs';
import { ValidationResult } from 'src/app/models/validation.result';
import { ApiService } from 'src/app/services/api.service';
import { Dictionary } from 'src/app/util/to-dictionary';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss'],
})
export class BankDetailsComponent implements OnInit {

  @Input() key: string;
  @Input() premium: string;

  @Output() back = new EventEmitter();
  @Output() continue = new EventEmitter();
  @Output() nextPageEvent = new EventEmitter<string>();

  message: string = "loading...";
  dispose$ = new Subject();
  loading: boolean = false;
  mode: 'intro' | 'questions' | 'contact-complete' | 'error' | 'confirm' | 'amend' | 'contact-request' = 'intro';
  answers: Dictionary<string> = {};

  OnViewDidEnter() {
    this.loading = false;
    this.mode = 'intro';
    this.message = "";
  }

  constructor(
    private api: ApiService
  ) { }

  async ngOnInit() {
    this.answers['BankVerificationFailed'] = '';
    this.answers['MagnumPremium'] = this.premium;
  }

  ngOnDestroy(): void {
    this.dispose$.next({});
  }

  async detailsConfirmed(result: ValidationResult) {
    this.loading = true;
    this.message = "Please wait..";
    try {
      if (result.valid) {
        await this.saveBanking();
        await this.savePolicyDateInfo();
        this.continue.emit();
      } else {
        const retryCount = parseInt(this.answers['ValidationRetryCount']);
        if (retryCount == 1) {
          this.answers['BankVerificationFailed'] = 'true';
          this.mode = 'amend';
        } else {
          this.mode = 'contact-request';
        }
      }
    } catch (err) {
      console.log('error saving bank details: %o', err);
      this.mode = 'error';
    } finally {
      this.loading = false;
    }
  }

  async saveBanking() {
    const dateStr = `${this.answers['BankVerificationFailedContactDate']} ${this.answers['BankVerificationFailedTimeslot']}`.trim();
    const preferredContactDate = dateStr ? parse(dateStr, 'yyyy-MM-dd HH:mm', 0) : null;

    var rsp = await this.api.saveBankDetails(this.key, {
      accountHolderName: this.answers['DirectDebitAccountHolderName'],
      accountNumber: this.answers['DirectDebitAccountNumber'],
      sortCode: this.answers['DirectDebitSortCode'],
      preferredContactDate
    });
  }

  async savePolicyDateInfo() {
    await this.api.savePolicyDateInfo(this.key, {
      directDebitDay: parseInt(this.answers['DirectDebitDay']),
      policyStartDate: parse(this.answers['DirectDebitPolicyStartDate'], 'yyyy-MM-dd', 0)
    });
  }

  async saveContactRequest() {
    this.loading = true;
    this.message = "Please wait..";
    try {
      await this.saveBanking();
      this.mode = 'contact-complete';
    } catch (err) {
      console.log('error saving bank details: %o', err);
      this.mode = 'error';
    } finally {
      this.loading = false;
    }
  }

  amendDetails() {
    this.answers['BankVerificationFailed'] = '';
    this.mode = 'confirm'
  }
}

